import axios from "@/api/axiosAuthRequired.js"
import { getAuthHeaders } from "./auth"

const CHAT_API_URL = process.env.CHAT_API_URL

export const checkTotalUnread = async () => {
  try {
    const { data } = await axios({
      method: "get",
      url: CHAT_API_URL + "api/conversations/unread-count",
      headers: getAuthHeaders(),
    })
    return data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const fetchChatConversations = async conversationPage => {
  try {
    const conversationPageSize = 20
    const { data } = await axios({
      method: "get",
      url: `${CHAT_API_URL}api/conversations?page=${conversationPage}&page_size=${conversationPageSize}`,
      headers: getAuthHeaders(),
    })
    return data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const fetchConversationById = async conversationId => {
  try {
    const url = `${CHAT_API_URL}api/conversations/${conversationId}`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getConversationMessages = async ({ conversation, before }) => {
  try {
    const url = `${CHAT_API_URL}api/conversations/${conversation.id}/messages`
    const config = {
      headers: getAuthHeaders(),
      params: {
        before,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const updateLastReadMessage = async (conversationId, messageId) => {
  try {
    const url = `${CHAT_API_URL}api/conversations/${conversationId}/last-read-message`
    const body = {
      message_id: messageId,
    }
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.put(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const sendMessage = async (conversationId, message) => {
  try {
    const url = `${CHAT_API_URL}api/conversations/${conversationId}/send-message`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.post(url, message, config)
    return res.data
  } catch (error) {
    console.error(error)
    setTimeout(() => {
      sendMessage(conversationId, message)
    }, 4000)
    return null
  }
}

export const loadChatUser = async () => {
  try {
    const url = `${CHAT_API_URL}api/user`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const createDirectConversation = async (user1, user2) => {
  try {
    const url = `${CHAT_API_URL}api/conversations/direct`
    const body = {
      user_id1: user1,
      user_id2: user2,
    }
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}



// WEBPACK FOOTER //
// ./src/api/messages.js